import FormGroupWithTooltip from '@/components/common/FormGroup/FormGroupWithTooltip';
import Select from '@/components/common/Select/Select';
import { IGenre } from '@/data/models/genre';
import { IOptions } from '@/data/models/option';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { TrackEditViewTemplateProps } from '../TrackEditViewTemplate';
import { BaseFormGroupProps } from './types';

type Props = Pick<
  TrackEditViewTemplateProps,
  | 'handleInput'
  | 'baseMixedTrack'
  | 'trackData'
  | 'fieldHasErrors'
  | 'fieldValidationState'
  | 'isMultipleTrack'
  | 'findErrorMessage'
  | 'areNewMultipleTracks'
> &
  BaseFormGroupProps & {
    trackKey: string;
    isLoadingCatalogs: boolean;
    genres: IOptions<IGenre>[];
    queryGenres: (inputText: string | null, callback: any) => void;
  };

export default function TrackGenreFormGroup({
  trackKey,
  isLoadingCatalogs,
  genres,
  queryGenres,
  trackData,
  baseMixedTrack,
  readonly,
  disabled,
  areNewMultipleTracks,
  isMultipleTrack,
  fieldHasErrors,
  fieldValidationState,
  findErrorMessage,
  handleInput,
}: Props) {
  const { t } = useTranslation();
  const isMixed =
    baseMixedTrack?.genre?.isMixed && baseMixedTrack?.genre?.value === 'Mixed';
  return (
    <FormGroupWithTooltip
      tooltipKey="tooltip.track.genre"
      hasErrors={
        !isMultipleTrack ? fieldHasErrors('Genre') && !trackData.genre : false
      }
    >
      <Select
        key={`genre-${trackKey}-${isLoadingCatalogs ? 'loading' : 'ready'}`}
        id="genre"
        labelTitle={t('product.editProduct.genre')}
        labelClass="col-sm-3 form-label"
        isClearable
        loadOptions={queryGenres}
        placeholder={isMixed ? t('track.mixed') : ''}
        data-testid="genre-select"
        onChange={(option) => handleInput('genre', option?.value ?? null)}
        initialOption={
          isMixed
            ? null
            : genres?.find((g) =>
                !isMultipleTrack
                  ? g.value?.id === trackData.genre?.id
                  : g.value?.id === (baseMixedTrack?.genre?.value as IGenre)?.id
              )
        }
        className={isMixed ? 'col-sm-6 mixed-genre' : 'col-sm-6'}
        isDisabled={disabled}
        isReadOnly={readonly}
        isLoading={isLoadingCatalogs}
        hasErrors={
          !isMultipleTrack ? fieldHasErrors('Genre') && !trackData.genre : false
        }
        validationState={
          !isMultipleTrack ? fieldValidationState?.('Genre') : undefined
        }
        errorMessage={!isMultipleTrack ? findErrorMessage('Genre') : ''}
        baseOptions={genres ?? []}
        multitrack={baseMixedTrack?.genre}
        showChangeIndicator={!areNewMultipleTracks}
        handleUndo={(value) => handleInput('genre', value)}
      />
    </FormGroupWithTooltip>
  );
}
